import constants from 'crm/common/constants'

const {tagType} = constants

export function sortTags(tags) {
    const personalTags = []
    const corpTags = []
    if (Array.isArray(tags)) {
        tags.forEach((group) => {
            const {type} = group
            if (type === tagType.personal.type) {
                personalTags.push(group)
            } else {
                corpTags.push(group)
            }
        })
    }
    return {personalTags, corpTags}
}

export function flatCorpTagValues(groupTags) {
    if (Array.isArray(groupTags)) {
        const newValues = []
        groupTags.forEach((group) => {
            if (Array.isArray(group.tags)) {
                group.tags.forEach((tag) => {
                    newValues.push({
                        group_id: group.group_id,
                        group_name: group.group_name,
                        ...tag,
                    })
                })
            }
        })
        return newValues
    }
}

export function getCorpTagIds(groupTags) {
    if (Array.isArray(groupTags)) {
        let newValues = []
        groupTags.forEach((group) => {
            if (Array.isArray(group.tags)) {
                newValues = newValues.concat(group.tags)
            }
        })
        return newValues.map((v) => ({id: v.id}))
    }
    return []
}

export function findDuplicateCorpTagNames(allCorpTags) {
    if (Array.isArray(allCorpTags)) {
        const allTagNames = allCorpTags.reduce((accumulator, currentGroup) => {
            const {tag: tags} = currentGroup
            if (Array.isArray(tags)) {
                const tagNames = tags.map((v) => v.name)
                accumulator.push(...tagNames)
            }
            return accumulator
        }, [])
        const sortedNames = allTagNames.sort()
        const results = []
        for (let i = 0; i < sortedNames.length - 1; i++) {
            if (sortedNames[i + 1] === sortedNames[i] && !results.includes(sortedNames[i])) {
                results.push(sortedNames[i])
            }
        }
        return results
    }
    return []
}

// 重名标签前加上分组名称
export function filterCorpTags(tags) {
    const tagNames = tags.map((tag) => tag.name)
    return tags.map((tag) => {
        const {name} = tag
        const excludedNames = tagNames.filter((tagName) => tagName !== name)
        if (excludedNames.length === tagNames.length - 1) {
            return tag.name
        }
        return `${tag.group_name}：${tag.name}`
    })
}
